import React, { memo } from 'react';
import { CommentsIcon } from './CommentsIcon';
import { Control } from '../RightControl';
import { Badge } from '../../../';
export const HeaderComments = memo(({ onClick, count = 0, active = false }) => (React.createElement(Control, { onClick: onClick, className: active ? 'active' : '' },
    React.createElement(Badge, { dot: !!count },
        React.createElement(CommentsIcon, null)))));
